import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const { color } = tokens

export const paperStyle = {
  borderRadius: 16
}

export const titleStyle = {
  position: 'relative',
  padding: '48px 40px 8px'
}

export const closeStyle = {
  position: 'absolute',
  right: 16,
  top: 16
}

// 12 px en vertical: el margen negativo de un Grid con spacing={3} cabe en el padding y no saca
// un scroll que no hace falta
export const contentStyle = {
  padding: '12px 40px',
  fontSize: 14,
  fontFamily: tokens.typography.fontFamily.primary,
  color: color.text.secondary
}

export const actionsStyle = {
  justifyContent: 'center',
  gap: 12,
  padding: 24
}

export const Title = styled.p`
  margin: 0;
  text-align: center;
  font-family: ${tokens.typography.fontFamily.primary};
  font-weight: 600;
  font-size: 18px;
  line-height: 1.4;
  color: ${color.text.primary};
  word-break: break-word;
  overflow-wrap: break-word;
`
